import React, { useEffect, useState } from "react";
import "../CSS/ProfileTenagaKesehatan.css";
import { useNavigate, useParams } from "react-router-dom";

function ProfileTenagaKesehatanAdmin() {
  const { id } = useParams();
  const [tkData, setTkData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const navigate = useNavigate();

  // Fetch data tenaga kesehatan
  useEffect(() => {
    const fetchTenaga = async () => {
      try {
        const res = await fetch(`https://api-tibismart.tifpsdku.com/api/${id}`);
        if (!res.ok) throw new Error("Gagal mengambil data tenaga kesehatan");
        const data = await res.json();
        console.log("FULL DATA:", data);
        console.log("EMAIL:", data.data?.Email);

        setTkData(data.data || data); 
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchTenaga();
  }, [id]);

  // Handle perubahan input
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "Email") {
      // update nested user.email
      setTkData((prev) => ({
        ...prev,
        Email: value
      }));
    } else {
      setTkData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle save data
  const handleSave = async () => {
    try {
      const payload = {
        NamaLengkap: tkData.NamaLengkap,
        NoTeleponTK: tkData.NoTeleponTK,
        NoSTR: tkData.NoSTR,
        NIP: tkData.NIP,
        Spesialisasi: tkData.Spesialisasi,
        AlamatFasilitasKesehatan: tkData.AlamatFasilitasKesehatan,
        Profesi: tkData.Profesi,
        Email: tkData.Email || ""
      };

      const res = await fetch(`https://api-tibismart.tifpsdku.com/api/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Gagal menyimpan perubahan");

      await res.json();
      setTkData(prev => ({ ...prev, ...payload }));
      setEditing(false);
      alert("Data berhasil diperbarui!");
    } catch (err) {
      console.error(err);
      alert("Terjadi kesalahan saat menyimpan data.");
    }
  };

  const handleAktivitasClick = () => {
    navigate(`/HalamanAktivitasTenagaKesehatanAdmin/${id}`);
  };

  if (loading) return <p>Loading data...</p>;
  if (!tkData) return <p>Data tidak ditemukan</p>;

  return (
    <div className="profile-page">
      <div className="main-contentprofile">
        <div className="content-profile">
          {/* Profile Card */}
          <div className="profile-card">
            <div className="profile-avatar">
              {tkData.foto_profil ? (
                <img
                  src={`https://api-tibismart.tifpsdku.com/${tkData.foto_profil}`}
                  alt={tkData.NamaLengkap}
                  className="avatar-image"
                />
              ) : (
                <span>{tkData.NamaLengkap ? tkData.NamaLengkap[0].toUpperCase() : "TK"}</span>
              )}
            </div>
            <div className="profile-info">
              <h3>{tkData.NamaLengkap}</h3>
              <p>{tkData.Profesi} - {tkData.AlamatFasilitasKesehatan}</p>
              <p className="nip">NIP. {tkData.NIP}</p>
            </div>
          </div>

          {/* Tabs */}
          <div className="tab-section">
            <button className="tab active">Informasi</button>

          </div>

          {/* Form Section */}
          <div className="form-sectionprofile">
            <div className="form-row">
              <div className="form-groupprofile">
                <label>Nama Lengkap</label>
                <input
                  type="text"
                  name="NamaLengkap"
                  value={tkData.NamaLengkap}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
              <div className="form-groupprofile">
                <label>Email</label>
                <input
                  type="text"
                  name="Email" // HARUS Email supaya Flask bisa baca
                  value={tkData.Email || ""}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. Telepon</label>
                <input
                  type="text"
                  name="NoTeleponTK"
                  value={tkData.NoTeleponTK}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
              <div className="form-groupprofile">
                <label>Spesialisasi</label>
                <input
                  type="text"
                  name="Spesialisasi"
                  value={tkData.Spesialisasi || ""}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>No. STR</label>
                <input
                  type="text"
                  name="NoSTR"
                  value={tkData.NoSTR}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
              <div className="form-groupprofile">
                <label>Alamat Fasilitas Kesehatan</label>
                <input
                  type="text"
                  name="AlamatFasilitasKesehatan"
                  value={tkData.AlamatFasilitasKesehatan}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-groupprofile">
                <label>NIP</label>
                <input
                  type="text"
                  name="NIP"
                  value={tkData.NIP}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
              <div className="form-groupprofile">
                <label>Profesi</label>
                <input
                  type="text"
                  name="Profesi"
                  value={tkData.Profesi}
                  onChange={handleInputChange}
                  readOnly={!editing}
                />
              </div>
            </div>

            <div className="verification-section">
              <h3>Dokumen Verifikasi</h3>

              <div className="verification-grid">

                {/* FOTO SELFIE */}
                <div className="verification-card">
                  <h4>Foto Verifikasi Wajah</h4>

                  {tkData.foto_verifikasi ? (
                    <>
                      <img
                        src={`https://api-tibismart.tifpsdku.com/${tkData.foto_verifikasi}`}
                        alt="Foto Verifikasi"
                        className="verification-image"
                      />

                      <a
                        href={`https://api-tibismart.tifpsdku.com/${tkData.foto_verifikasi}`}
                        target="_blank"
                        rel="noreferrer"
                        className="download-btn"
                      >
                        Lihat Full Foto
                      </a>
                    </>
                  ) : (
                    <p>Foto verifikasi tidak tersedia</p>
                  )}
                </div>

                {/* DOKUMEN */}
                <div className="verification-card">
                  <h4>Dokumen Verifikasi</h4>

                  {tkData.dokumen_verifikasi ? (
                    <>
                      <p>
                        {tkData.dokumen_verifikasi.split("/").pop()}
                      </p>

                      <a
                        href={`https://api-tibismart.tifpsdku.com/${tkData.dokumen_verifikasi}`}
                        target="_blank"
                        rel="noreferrer"
                        className="download-btn"
                      >
                        Buka Dokumen
                      </a>

                      <a
                        href={`https://api-tibismart.tifpsdku.com/${tkData.dokumen_verifikasi}`}
                        download
                        className="download-btn secondary"
                      >
                        Download
                      </a>
                    </>
                  ) : (
                    <p>Dokumen tidak tersedia</p>
                  )}
                </div>

              </div>
            </div>

            <div className="btn-edit-container">
              {!editing ? (
                <button className="edit-btn" onClick={() => setEditing(true)}>Edit Profile</button>
              ) : (
                <button className="edit-btn" onClick={handleSave}>Simpan Perubahan</button>
              )}
            </div>
          </div>


          <footer className="footerdebar">
            © 2025 TibiSmart. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );
}

export default ProfileTenagaKesehatanAdmin;
